/**
 * Date helper utilities
 */

export function toDateOrNull(dateString?: string): Date | null {
  if (!dateString || dateString.startsWith('1970-01-01')) {
    return null;
  }
  try {
    const date = new Date(dateString.endsWith('Z') ? dateString : dateString + 'Z');
    return isNaN(date.getTime()) ? null : date;
  } catch {
    return null;
  }
}

export function maxDate(dates: (Date | null | undefined)[]): Date | null {
  const validDates = dates.filter((d): d is Date => d instanceof Date);
  if (validDates.length === 0) return null;
  return new Date(Math.max(...validDates.map((d) => d.getTime())));
}

export function daysAgo(date: Date): number {
  return Math.floor((Date.now() - date.getTime()) / (1000 * 60 * 60 * 24));
}

export function hoursAgo(date: Date): number {
  return Math.floor((Date.now() - date.getTime()) / (1000 * 60 * 60));
}

export function formatTimeAgo(date: Date | undefined): string {
  if (!date) return 'N/A';
  
  const hours = hoursAgo(date);
  if (hours < 1) return 'just now';
  if (hours < 24) return `${hours}h ago`;
  
  const days = daysAgo(date);
  return `${days}d ago`;
}

export function formatDate(date: Date | undefined): string {
  if (!date) return 'N/A';
  return date.toISOString().slice(0, 19).replace('T', ' ');
}
